export const stopPropagation = <F extends (e: Event) => void>(fn: F) =>
  // oxlint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- preserves caller handler type
  ((e) => {
    e?.stopPropagation?.()
    return fn(e)
  }) as F
